import { render, staticRenderFns } from "./SendPackge.vue?vue&type=template&id=7097418f&scoped=true"
import script from "./SendPackge.vue?vue&type=script&lang=js"
export * from "./SendPackge.vue?vue&type=script&lang=js"
import style0 from "./SendPackge.vue?vue&type=style&index=0&id=7097418f&prod&lang=less&scoped=true"
import style1 from "./SendPackge.vue?vue&type=style&index=1&id=7097418f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7097418f",
  null
  
)

export default component.exports